export default __webpack_public_path__ + "static/media/male.e3a255c5.svg";